var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1568 219L1568 247",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1568.5,
    cy: 214.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1563.99 214.19C1563.99 210.283 1567.29 207.117 1571.36 207.117C1571.94 207.117 1572.51 207.184 1573.06 207.308C1571.74 206.48 1570.19 206 1568.52 206C1563.81 206 1560 209.806 1560 214.5C1560 219.194 1563.81 223 1568.52 223C1570.81 223 1572.89 222.093 1574.43 220.62C1573.49 221.032 1572.45 221.263 1571.36 221.263C1567.29 221.263 1563.99 218.096 1563.99 214.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1577.4 213.6L1577.37 211.146L1575.54 212.719L1573.3 212.056L1574.11 214.337L1572.77 216.381L1575.1 216.218L1576.5 218.144L1577.13 215.763L1579.34 214.909L1577.4 213.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch5);
export default __webpack_public_path__ + "static/media/church_5.04c2774843698aef82c6b2bf3246db57.svg";
export { ForwardRef as ReactComponent };